import { getBrochures, getImages, getPodcasts } from "../../libs/learn-more";

import MuiMarkdown from "../custom-material/mui-markdown/MuiMarkdown";
import PagedDialogComponent from "../common/PagedDialogComponent";
import PropTypes from "prop-types";
import React from "react";

class LearnMoreDialogComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { imagesOrMarkdown: null, brochures: null, podcasts: null };
  }

  componentWillMount() {
    this._getState(this.props);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props === prevProps) return;
    this._getState(this.props);
  }

  _getState(props) {
    const { majorCategory, minorCategory, subClass, productName } = props;

    const imagesOrMarkdown = getImages(
      majorCategory,
      minorCategory,
      subClass,
      productName
    );

    if (imagesOrMarkdown.then) {
      // it's a promise
      imagesOrMarkdown.then((x) => this.setState({ imagesOrMarkdown: x }));
    } else {
      this.setState({ imagesOrMarkdown });
    }

    let brochures = getBrochures(
      majorCategory,
      minorCategory,
      subClass,
      productName
    );
    if (brochures.then) {
      // it's a promise
      brochures.then((x) => this.setState({ brochures: x }));
    } else {
      if (productName === "Pharma" || productName === "Biologics") {
        brochures = brochures.map((x, i) => {
          if (typeof x === "string") {
            return {
              path: x,
              name: i === 0 ? "U.S." : "Global",
            };
          }
          return x;
        });
      }
      this.setState({ brochures });
    }

    const podcasts = getPodcasts(
      majorCategory,
      minorCategory,
      subClass,
      productName
    );
    this.setState({ podcasts });
  }

  render() {
    // use origin so this will work when used as a webcomponent somewhere else
    const {
      dialogOpen,
      handleCloseDialog,
      productName,
      contact,
      origin,
    } = this.props;
    const { imagesOrMarkdown, brochures, podcasts } = this.state;
    if (imagesOrMarkdown === null) return null;

    const emailTo = "healthcare@ipdanalytics.com";
    const emailSubject = `Interested in a ${productName} Demo`;
    const emailBody = `I am interested in a demo of ${
      productName || ""
    }. Please contact me with more information.\n\nThanks!`;

    return (
      <PagedDialogComponent
        dialogOpen={dialogOpen}
        handleCloseDialog={handleCloseDialog}
        origin={origin}
        contact={contact}
        items={imagesOrMarkdown}
        brochurePath={brochures}
        podcasts={podcasts}
        emailTo={emailTo}
        emailSubject={emailSubject}
        emailBody={emailBody}
      >
        {(item, classes) =>
          typeof item === "string" ? (
            <img
              className={classes.learnMoreImage}
              src={`${origin || ""}/learn-more-images/${item}`}
              alt="Learn More"
            />
          ) : (
            <MuiMarkdown>{item.value}</MuiMarkdown>
          )
        }
      </PagedDialogComponent>
    );
  }
}

LearnMoreDialogComponent.propTypes = {
  dialogOpen: PropTypes.bool,
  handleCloseDialog: PropTypes.func,
  majorCategory: PropTypes.string,
  minorCategory: PropTypes.string,
  subClass: PropTypes.string,
  productName: PropTypes.string,
  groupName: PropTypes.string,
  contact: PropTypes.object,
  origin: PropTypes.string,
};

export default LearnMoreDialogComponent;
